import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'

import sagas from './sagas'
import createRootReducer from './reducers'

export const history = createBrowserHistory()

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()

let middlewares = [sagaMiddleware, routerMiddleware(history)]
export const store = createStore(createRootReducer(history), {}, process.env.REACT_APP_NODE_ENV == 'development' ? composeWithDevTools(applyMiddleware(...middlewares)) : applyMiddleware(...middlewares))
export const configureStore = () => {
  sagaMiddleware.run(sagas)
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers')
      store.replaceReducer(nextRootReducer)
    })
  }
  return store
}
